<template>
  <div id="echartsWordcloud"></div>
</template>
<script>
import searchApi from '@/api/search.js'
const colors = ['#f9d770', '#f8bc31', '#4d4030', '#daa45a', '#8e804b', '#fa7e23', '#ffa40f', '#954416', '#773d31', '#5d3131', '#a7535a', '#e3b4b8']
export default {
  mounted () {
    // let data = [
    //   { name: '中药', value: '283' },
    //   { name: '方剂', value: '101' },
    //   { name: '事件', value: '148' }
    // ]
    // this.initEcharts(data)
    this.initChart();
  },
  methods: {
    initChart () {
      searchApi.selectWordCloud({
        pageSize: this.$isPhone ? 20 : 100
      }).then(res => {
        let data = [];
        res.rows.forEach(item => {
          data.push({
            name: item.word,
            value: item.frequency
          });
        });
        this.setChart(data);
      })
    },
    setChart (data) {
      let echartsWordcloud = this.$echarts.init(document.getElementById('echartsWordcloud'))
      let option = {
        title: {
          text: '',
          x: 'center'
        },
        series: [
          {
            type: 'wordCloud',
            // 用来调整词之间的距离
            gridSize: this.$isPhone ? 50 : 10,
            // 用来调整字的大小范围
            sizeRange: this.$isPhone ? [36, 52] : [14, 26],
            rotationRange: [0, 0],
            // rotationStep: 45,
            // 随机生成字体颜色
            // 位置相关设置
            shape: 'square',
            left: 'center',
            top: 'center',
            right: null,
            bottom: null,
            width: '88%',
            height: '84%',
            // 数据
            data: data.map((item, index) => {
              return {
                ...item,
                textStyle: {
                    color: colors[index % 12],
                    fontFamily: 'FangZhengKaiTi-GBK'
                }
              }
            })
          }
        ]
      }
      echartsWordcloud.setOption(option)
      // 点击事件
      echartsWordcloud.on('click', (e) => {
        let url = window.location.origin + window.location.pathname
        this.$bus.$emit('openLogin', {
          url: `${url}#/literature?input=${e.name}&category=all&tcmGenreClassification=`
        })
      })
    }
  }
}
</script>
<style lang="less">
@import "~@/styles/variables.less";
#echartsWordcloud {
  width: 100%;
  height: 456px;
  background-image: url("~@/assets/images/source-bg.png");
  background-size: 100% 100%;
}
</style>
